export default __webpack_public_path__ + "static/media/order1.37ef97a0.svg";